"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/SmtpTokens/actions");

var _modalActions = require("../actions/interactions/modalActions");

var _tableActions = require("../actions/interactions/tableActions");

var _TypeFilter = _interopRequireDefault(require("../constants/TypeFilter"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  createFooterModalOpen: false,
  createSmtpTokenModalOpen: false,
  createTypeModalOpen: false,
  deleteFooterModalOpen: false,
  deleteFooterSelectedId: null,
  deleteSmtpTokenModalOpen: false,
  deleteSmtpTokenSelectedId: null,
  makeFooterDefaultModalOpen: false,
  makeFooterDefaultSelectedId: null,
  mostRecentlyCreatedSmtpTokenId: null,
  resetSmtpTokenPasswordModalOpen: false,
  resetSmtpTokenPasswordSelectedId: null,
  setBccEmailModalOpen: false,
  typesTableFilter: _TypeFilter.default.ACTIVE,
  typesTableLanguageFilter: 'default',
  updateFooterModalOpen: false,
  updateFooterSelectedId: null,
  emailCreationModalData: {},
  emailCreationModalOpen: false,
  emailCreationModalType: null,
  updateTypeModalOpen: false,
  updateTypeSelectedId: null
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_CREATE_FOOTER_MODAL, function (state) {
  return state.set('createFooterModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_CREATE_SMTP_TOKEN_MODAL, function (state) {
  return state.set('createSmtpTokenModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_CREATE_TYPE_MODAL, function (state) {
  return state.set('createTypeModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_DELETE_FOOTER_MODAL, function (state, action) {
  return state.set('deleteFooterModalOpen', true).set('deleteFooterSelectedId', action.payload.id);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_DELETE_SMTP_TOKEN_MODAL, function (state, action) {
  return state.set('deleteSmtpTokenModalOpen', true).set('deleteSmtpTokenSelectedId', action.payload.id);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_MAKE_FOOTER_DEFAULT_MODAL, function (state, action) {
  return state.set('makeFooterDefaultModalOpen', true).set('makeFooterDefaultSelectedId', action.payload.id);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_RESET_SMTP_TOKEN_PASSWORD_MODAL, function (state, action) {
  return state.set('resetSmtpTokenPasswordModalOpen', true).set('resetSmtpTokenPasswordSelectedId', action.payload.id);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_SET_BCC_EMAIL_MODAL, function (state) {
  return state.set('setBccEmailModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_UPDATE_FOOTER_MODAL, function (state, action) {
  return state.set('updateFooterModalOpen', true).set('updateFooterSelectedId', action.payload.id);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_EMAIL_CREATION_MODAL, function (state, action) {
  var _action$payload$modal = action.payload.modalData,
      type = _action$payload$modal.type,
      data = (0, _objectWithoutProperties2.default)(_action$payload$modal, ["type"]);
  return state.set('emailCreationModalOpen', true).set('emailCreationModalType', type).set('emailCreationModalData', data);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.OPEN_UPDATE_TYPE_MODAL, function (state, action) {
  return state.set('updateTypeModalOpen', true).set('updateTypeSelectedId', action.payload.id);
}), (0, _defineProperty2.default)(_handleActions, _modalActions.ModalActionTypes.CLOSE_MODAL, function (state) {
  return state.merge({
    createFooterModalOpen: false,
    createSmtpTokenModalOpen: false,
    createTypeModalOpen: false,
    deleteFooterModalOpen: false,
    deleteFooterSelectedId: null,
    deleteSmtpTokenModalOpen: false,
    deleteSmtpTokenSelectedId: null,
    makeFooterDefaultModalOpen: false,
    makeFooterDefaultSelectedId: null,
    resetSmtpTokenPasswordModalOpen: false,
    resetSmtpTokenPasswordSelectedId: null,
    setBccEmailModalOpen: false,
    updateFooterModalOpen: false,
    updateFooterSelectedId: null,
    emailCreationModalOpen: false,
    emailCreationModalType: null,
    emailCreationModalData: {},
    updateTypeModalOpen: false,
    updateTypeSelectedId: null
  });
}), (0, _defineProperty2.default)(_handleActions, _tableActions.TableActionTypes.FILTER_TYPES_TABLE, function (state, action) {
  return state.set('typesTableFilter', action.payload.type);
}), (0, _defineProperty2.default)(_handleActions, _tableActions.TableActionTypes.FILTER_TYPES_TABLE_LANGUAGE, function (state, action) {
  return state.set('typesTableLanguageFilter', action.payload.languageCode);
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateSmtpTokenActionTypes.SUCCESS, function (state, action) {
  return state.set('mostRecentlyCreatedSmtpTokenId', action.payload.data.userName);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;